export class City {
  constructor(id, name) {
    this.id = id;
    this.name = name;
  }

  // set cities from response array
  static setCities(cities) {
    return cities.map((city) => new City(city.id, city.name));
  }
}
